// Translations for the dashboard
const translations = {
  en: {
    dashboard: "Dashboard",
    analytics: "Advanced Analytics",
    alerts: "AI Alerts",
    reports: "Reports",
    settings: "Settings",
    manufacturingEdition: "Manufacturing Edition",
    operationalEfficiency: "Operational Efficiency",
    vsLastMonth: "vs last month",
    qualityRate: "Quality Rate",
    predictiveAlerts: "Predictive Alerts",
    requiringAttention: "requiring attention",
    costOptimization: "Cost Optimization",
    potentialSavings: "potential savings",
    performanceTrends: "Performance Trends",
    aiInsight: "AI Insight:",
    efficiencyInsight: "Efficiency improvement correlates with reduced maintenance cycles. Consider adjusting preventive maintenance schedule based on AI-driven optimization.",
    resourceUtilization: "Resource Utilization",
    energyInsight: "Energy efficiency is below target. AI models suggest potential 15% improvement by optimizing equipment startup sequences and balancing loads.",
    aiPoweredAlerts: "AI-Powered Predictive Alerts",
    viewAll: "View All",
    equipment: "Equipment",
    issue: "Issue",
    risk: "Risk",
    aiRecommendation: "AI Recommendation",
    action: "Action",
    address: "Address",
    operationsDashboard: "Manufacturing Operations Dashboard",
    searchAnalytics: "Search analytics...",
    generateReport: "Generate Report",
    realTimeMonitoring: "Real-time production monitoring",
    predictiveMaintenance: "Predictive maintenance",
    qualityControl: "Quality control analytics",
    high: "High",
    medium: "Medium",
    low: "Low",
    viewDetails: "View Details",
    resolve: "Resolve",
    customAnalysisBuilder: "Custom Analysis Builder",
    createCustomAnalytics: "Create custom analytics by selecting manufacturing variables and applying AI models.",
    selectDataSource: "Select Data Source",
    analysisType: "Analysis Type",
    timePeriod: "Time Period",
    generateAnalysis: "Generate Analysis",
    productionLineData: "Production Line Data",
    qualityControlMetrics: "Quality Control Metrics",
    maintenanceRecords: "Maintenance Records",
    energyConsumption: "Energy Consumption",
    supplyChainData: "Supply Chain Data",
    correlationAnalysis: "Correlation Analysis",
    trendForecasting: "Trend Forecasting",
    anomalyDetection: "Anomaly Detection",
    rootCauseAnalysis: "Root Cause Analysis",
    customMLModel: "Custom ML Model",
    last7Days: "Last 7 Days",
    last30Days: "Last 30 Days",
    lastQuarter: "Last Quarter",
    yearToDate: "Year to Date",
    customRange: "Custom Range",
    configureAlerts: "Configure Alerts",
    activeAlerts: "Active Alerts",
    priority: "Priority",
    type: "Type",
    description: "Description",
    detected: "Detected",
    status: "Status",
    actions: "Actions",
    quality: "Quality",
    open: "Open",
    inProgress: "In Progress",
    hoursAgo: "hours ago",
    assemblyLineAlert: "Assembly Line 3 showing anomalous vibration patterns",
    defectRateAlert: "Defect rate increasing above threshold at Quality Station 2",
    reportsDescription: "The reports section contains automated manufacturing reports and analytics.",
    settingsDescription: "Configure your AI analytics preferences and integrations here.",
    anomalousVibration: "Anomalous vibration pattern detected",
    predictiveMaintenance72: "Predictive maintenance needed within 72 hours",
    defectRateIncrease: "Defect rate increasing above threshold",
    calibrationDrift: "Calibration parameters drifting from optimal",
    inventoryAnomaly: "Inventory forecasting anomaly",
    supplyChainDisruption: "Potential supply chain disruption in next cycle",
    assemblyLine3: "Assembly Line 3",
    qualityStation2: "Quality Station 2",
    materialHandling: "Material Handling",
    machineUtilization: "Machine Utilization",
    humanResources: "Human Resources",
    energyEfficiency: "Energy Efficiency",
    materialsYield: "Materials Yield",
    efficiency: "Efficiency",
    defects: "Defects",
    maintenance: "Maintenance",
    target: "Target",
    month: "Month",
    percentage: "Percentage",
    jan: "Jan",
    feb: "Feb",
    mar: "Mar",
    apr: "Apr",
    may: "May",
    jun: "Jun",
    jul: "Jul",
    backToPortal: "Back to Portal"
  },
  zh: {
    dashboard: "仪表板",
    analytics: "高级分析",
    alerts: "AI 警报",
    reports: "报告",
    settings: "设置",
    manufacturingEdition: "制造业版",
    operationalEfficiency: "运营效率",
    vsLastMonth: "与上月相比",
    qualityRate: "质量率",
    predictiveAlerts: "预测警报",
    requiringAttention: "需要关注",
    costOptimization: "成本优化",
    potentialSavings: "潜在节省",
    performanceTrends: "性能趋势",
    aiInsight: "AI 洞察:",
    efficiencyInsight: "效率提高与减少维护周期相关。考虑根据 AI 驱动的优化调整预防性维护计划。",
    resourceUtilization: "资源利用",
    energyInsight: "能源效率低于目标。AI 模型表明，通过优化设备启动序列和平衡负载，可能提高 15% 的效率。",
    aiPoweredAlerts: "AI 驱动的预测警报",
    viewAll: "查看全部",
    equipment: "设备",
    issue: "问题",
    risk: "风险",
    aiRecommendation: "AI 建议",
    action: "操作",
    address: "处理",
    operationsDashboard: "制造业运营仪表板",
    searchAnalytics: "搜索分析...",
    generateReport: "生成报告",
    realTimeMonitoring: "实时生产监控",
    predictiveMaintenance: "预测性维护",
    qualityControl: "质量控制分析",
    high: "高",
    medium: "中",
    low: "低",
    viewDetails: "查看详情",
    resolve: "解决",
    customAnalysisBuilder: "自定义分析构建器",
    createCustomAnalytics: "通过选择制造变量和应用AI模型创建自定义分析。",
    selectDataSource: "选择数据源",
    analysisType: "分析类型",
    timePeriod: "时间段",
    generateAnalysis: "生成分析",
    productionLineData: "生产线数据",
    qualityControlMetrics: "质量控制指标",
    maintenanceRecords: "维护记录",
    energyConsumption: "能源消耗",
    supplyChainData: "供应链数据",
    correlationAnalysis: "相关性分析",
    trendForecasting: "趋势预测",
    anomalyDetection: "异常检测",
    rootCauseAnalysis: "根本原因分析",
    customMLModel: "自定义机器学习模型",
    last7Days: "最近7天",
    last30Days: "最近30天",
    lastQuarter: "最近一季度",
    yearToDate: "年初至今",
    customRange: "自定义范围",
    configureAlerts: "配置警报",
    activeAlerts: "活动警报",
    priority: "优先级",
    type: "类型",
    description: "描述",
    detected: "检测时间",
    status: "状态",
    actions: "操作",
    quality: "质量",
    open: "待处理",
    inProgress: "处理中",
    hoursAgo: "小时前",
    assemblyLineAlert: "装配线3显示异常振动模式",
    defectRateAlert: "质量站2的缺陷率高于阈值",
    reportsDescription: "报告部分包含自动生成的制造报告和分析。",
    settingsDescription: "在此配置您的AI分析首选项和集成。",
    anomalousVibration: "检测到异常振动模式",
    predictiveMaintenance72: "需要在72小时内进行预测性维护",
    defectRateIncrease: "缺陷率高于阈值",
    calibrationDrift: "校准参数偏离最佳值",
    inventoryAnomaly: "库存预测异常",
    supplyChainDisruption: "下一周期可能出现供应链中断",
    assemblyLine3: "装配线3",
    qualityStation2: "质量工作站2",
    materialHandling: "物料处理",
    machineUtilization: "机器利用率",
    humanResources: "人力资源",
    energyEfficiency: "能源效率",
    materialsYield: "材料产出率",
    efficiency: "效率",
    defects: "缺陷",
    maintenance: "维护",
    target: "目标",
    month: "月份",
    percentage: "百分比",
    jan: "一月",
    feb: "二月",
    mar: "三月",
    apr: "四月",
    may: "五月",
    jun: "六月",
    jul: "七月",
    backToPortal: "返回主页"
  }
};

export default translations; 